<template>
  <div>
    <el-form label-width="90px" class="query-form">
      <el-row :gutter="10" class="mobile-row">
        <el-col :span="6" class="mobile-col">
          <el-date-picker v-model="beginTime" type="date" placeholder="开始日期"/>
        </el-col>
        <el-col :span="6" class="mobile-col">
          <el-date-picker v-model="endTime" type="date" placeholder="结束日期"/>
        </el-col>
        <el-col :span="6" class="mobile-col">
          <el-button type="primary" @click="fetchData" class="query-button">查询</el-button>
        </el-col>
      </el-row>
    </el-form>

    <el-table :data="tableData" border style="width:100%">
      <el-table-column prop="advName" label="名称"/>
      <el-table-column prop="cost" label="消费汇总" :formatter="formatCost" sortable/>
    </el-table>
  </div>
</template>

<script>
import sha1 from 'sha1'

export default {
  data() {
    return {
      beginTime:'',
      endTime:'',
      tableData:[]
    }
  },
  mounted(){
    const d=new Date(); d.setDate(d.getDate()-1)
    this.beginTime=d; this.endTime=d; this.fetchData()
  },
  methods:{
    formatCost(r,c,v){ return Number(v||0).toFixed(2) },
    formatDate(d){
      d=new Date(d)
      return `${d.getFullYear()}${String(d.getMonth()+1).padStart(2,'0')}${String(d.getDate()).padStart(2,'0')}`
    },
    generateToken(o,i,k){
      const t=Math.floor(Date.now()/1000)
      return btoa(`${o},${i},${t},${sha1(i+k+t)}`)
    },
    fetchData(){
      const zzh=[
        { advName:'知了答题', owner_id:'1001020442', api_id:'0e7f5033c1a14bc8bb6911ef74e94c0c', api_key:'15409bfbc2364a28b60cdcd0a0f3ea59' ,owner_type:"0"},
        { advName:'账界', owner_id:'1001020439', api_id:'ba22baf2e69a402f9c404dcb10ac9cb1', api_key:'7017eb19f5464635baaea96eb32a6280' ,owner_type:"0"},
        { advName:'待办星盒', owner_id:'1001020435', api_id:'c4d48cb7f19849dba0a645e10e6a8760', api_key:'5a54c9c32a104169b5a455ae82bcecdd' ,owner_type:"0"},
        { advName:'SMBHEF-海南量氪-三级', owner_id:'1000487400', api_id:'af97654542a44375b0e7232e4c4166c3', api_key:'3ebe4a789e3742ed94b5557063d71104' ,owner_type:"0"},
        { advName:'SMBYP-量氪2-二级', owner_id:'1001000869', api_id:'4b69ce7d1b3943c49c8404307ac746f4', api_key:'5a6e65e8382040408737c347347ba284' ,owner_type:"0"},
        { advName:'SMBSZ-码力连-三级-XXL', owner_id:'1001078195', api_id:'5df40d1766ea4211ad8874c9f2f76801', api_key:'cf3513d4511147eea86d847b874650a3',owner_type:"0" },
        { advName:'SMBSZ-复驷快应用-三级-XXL', owner_id:'1000815980', api_id:'7174125b363d40c5ae53417f9d49eb28', api_key:'bdfac6b3a2f1443bbbdfba8c472682bc',owner_type:"0" },
        { advName:'SMBYP-复驷快应用3-二级', owner_id:'1000935770', api_id:'ae588724d11045f5b8106283cde10762', api_key:'0ce1d82b71ab44cd917514c2016fb4b3',owner_type:"0" },
        { advName:'SMBSZ-诚鑫02-三级-XXL', owner_id:'1001062301', api_id:'714ca8aca95c468d988e44c89c68ca89', api_key:'2b5f4f61722a4ebab4b56dd1d0ddf457',owner_type:"0"},
        { advName:'SMBYP-诚鑫-二级', owner_id:'1000980733', api_id:'b9732c0abf074fa4b118933412c11f8d', api_key:'7c5cdb81eb1049e39814d267b936a0dc',owner_type:"0" },

        { advName:'SMBHEF-K（西安屿云04）-二级', owner_id:'1000994089', api_id:'fd6a1f6daf9c4dab90ce974204acc133', api_key:'811f9ee156724a1c818b44c704173ae0',owner_type:"3" },

        { advName:'SMBHEF-华朝短剧-zv-三级', owner_id:'1001098905', api_id:'96a68eeaacd240bfa58fecdf35d3d4aa', api_key:'dd8485ab9bd742f9a15ed7102dcfafca' ,owner_type:"0"},
        { advName:'SMBHEF-萌欢短剧-zv-三级', owner_id:'1001098902', api_id:'3dd46aa66fe04e66b5be147209d8ae7a', api_key:'c8a3a09c41c14359856f5774a8b9b817',owner_type:"0" },
        { advName:'SMBHEF-仕影快剧场-zv-三级', owner_id:'1001098898', api_id:'fe124147cc3d48fcb42d495cfff3407c', api_key:'dd27de74b64f4df89aa450610907030f' ,owner_type:"0"},
        { advName:'SMBHEF-仕优购享-zv-三级', owner_id:'1001098856', api_id:'89b71f959a254e7d9360bc3d63b75848', api_key:'d6304f5a98da4d37b9388790d67cace6',owner_type:"0" },

        { advName:'SMBSZ-量氪3-三级', owner_id:'1001140079', api_id:'91c2477f466e49b4b5ab7c6499ff0104', api_key:'2e4195dfa91f48d1b4d334c4f3008bd6' ,owner_type:"0"},
        { advName:'SMBSZ-阿斯塔特-三级-XXL', owner_id:'1001115234', api_id:'1ebb23db6e9e4ad4945eae8b4f4fd8ec', api_key:'c6545a8bd8cf47809914900f48ca2a67',owner_type:"0" },
        { advName:'SMBYP-阿斯塔-二级', owner_id:'1001132608', api_id:'564d1e3a28684273aec3ffcece2711cf', api_key:'dd97ceae62ac43c19ee2adaba02fbcc4' ,owner_type:"3"},

        { advName:'三级 SMBSZ-小雪之纯-三级-XXL', owner_id:'1001197808', api_id:'36699be1a714463fba739a6e6320477e', api_key:'f700b24c546a4b8faee51ec0e1e45aa6' ,owner_type:"0"},
          { advName:'SMBSZ-周末菜谱-三级-XXL', owner_id:'1001225293', api_id:'e0622c934edb42a9bf1f6efd03ed93a8', api_key:'284bb75e471c49e0912ec3219c4eade1' ,owner_type:"0"},

      ]

      const reqs=zzh.map(a=>{
        const body={
          page:1,pageCount:500,
          beginTime:this.formatDate(this.beginTime),
          endTime:this.formatDate(this.endTime),
          timeLevel:'DAY',
          paraMap: {
            subAccList: ["1", "0", "9999"],
            owner_type: a.owner_type,
            extensionFlowList: ["1", "2","3"],
            flowSceneList: ["0","1", "2","3","4","5","6", "7", "8", "9", "10", "11","12","13","14","15"],
            groupByColumn: "owner_id"
          }
        }

        return this.$axios.post(
          'apis/v3/data/common/agency/query/queryOwnerCost',
          body,
          { headers:{ Authorization:`Bearer ${this.generateToken(a.owner_id,a.api_id,a.api_key)}` } }
        ).then(r=>{
          const list=r.data.data.items||[]
          const total=list.reduce((s,i)=>s+Number(i.cost||0),0)
          return { advName:a.advName, cost: total/100 }
        })
      })

      Promise.all(reqs).then(res=>{
        const grand=res.reduce((s,i)=>s+Number(i.cost||0),0)
        this.tableData=[{ advName:'总计', cost:grand }, ...res]
      })
    }
  }
}
</script>

<style scoped>
@media (max-width:768px){
  .mobile-col{width:100%!important;display:block}
  .query-button{width:100%;margin-top:8px}
}
</style>



// WEBPACK FOOTER //
// src/components/login/oppofujianAll.vue